import React, { Component } from 'react';
import ccm1 from '../images/ccm1.png';
import ccm2 from '../images/ccm2.png';
import ccm3 from '../images/ccm3.png';
import ccm4 from '../images/ccm4.png';

const ImageStyle = {
    height: '10rem',
    width: 'auto',
    mixBlendMode: 'colorBurn',
};

class Ccm extends Component {
    render() {
        return (
            <div className="mt-8 bg-gray-100">
                <section data-aos="fade-up">
                    <div className="my-4 py-4">
                        <h2 className="mt-4 mx-12 text-center text-xl lg:text-l font-semibold text-gray-400">Fonctionnement</h2>
                        <h2 className="my-2 text-center text-3xl text-red-700 uppercase font-bold">Comment ça marche</h2>
                        <div className="flex justify-center">
                            <div className="w-24 border-b-4 border-red-700"></div>
                        </div>
                    </div>

                    <div className="p-16" data-aos="fade-in" data-aos-delay="600">
                        <div className="grid sm:grid-cols-1 lg:grid-cols-4 gap-8 text-center">
                            <div className="overflow-hidden p-4 flex flex-col items-center transition-all ease-in-out opacity-80 hover:opacity-100">
                                <img src={ccm1} alt="Ajoutez un article" style={ImageStyle} />
                                <h1 className="text-xl font-bold mt-4">Ajoutez un article</h1>
                                <p className="text-gray-600 mt-2">Ajoutez quelques photos, la description, le prix et en moins de 30 secondes, votre dressing est en ligne disponible à la vente pour des milliers de Dabchouchas.</p>
                            </div>

                            <div className="overflow-hidden p-4 flex flex-col items-center transition-all ease-in-out opacity-80 hover:opacity-100">
                                <img src={ccm2} alt="Livrez" style={ImageStyle} />
                                <h1 className="text-xl font-bold mt-4">Livrez</h1>
                                <p className="text-gray-600 mt-2">Emballez votre article et laissez un petit mot sympa. Un livreur viendra récupérer le colis directement depuis chez vous.</p>
                            </div>

                            <div className="overflow-hidden p-4 flex flex-col items-center transition-all ease-in-out opacity-80 hover:opacity-100">
                                <img src={ccm3} alt="Encaissez" style={ImageStyle} />
                                <h1 className="text-xl font-bold mt-4">Encaissez</h1>
                                <p className="text-gray-600 mt-2">24h après la livraison de l'article, vous recevrez automatiquement votre argent sur votre compte bancaire ou sur votre carte e-dinar.</p>
                            </div>

                            <div className="overflow-hidden p-4 flex flex-col items-center transition-all ease-in-out opacity-80 hover:opacity-100">
                                <img src={ccm4} alt="Achetez" style={ImageStyle} />
                                <h1 className="text-xl font-bold mt-4">Achetez</h1>
                                <p className="text-gray-600 mt-2">A votre tour, dénichez de très beaux articles directement dans les dressings d'autres femmes et faites-vous livrer chez vous en toute sécurité.</p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Ccm;
